import { render, staticRenderFns } from "./ingredients.vue?vue&type=template&id=24692b80&"
import script from "./ingredients.vue?vue&type=script&lang=js&"
export * from "./ingredients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports